var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-left"},[_c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"unique-opened":true,"default-openeds":_vm.openeds,"collapse":_vm.isCollapse}},[_c('menu-tree',{attrs:{"menuList":_vm.routes}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }